import React from 'react';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectFilteredCipRegisters,
  selectCipRegisterLoading,
  selectFetchCipRegisterLoading,
} from './store/selectors';
import { deleteCipRegister, fetchCipRegisterById } from './store/slice';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';

const CipRegisterTable = () => {
  const dispatch = useDispatch();
  const filteredData = useSelector(selectFilteredCipRegisters);
  const isLoading = useSelector(selectCipRegisterLoading);
  const isFetchDataLoading = useSelector(selectFetchCipRegisterLoading);

  const handleEdit = record => {
    dispatch(fetchCipRegisterById(record.id));
  };

  const handleDelete = id => {
    dispatch(deleteCipRegister(id));
  };

  const columns = [
    {
      title: 'CR #',
      dataIndex: 'crNumber',
      sorter: (a, b) => a.crNumber.localeCompare(b.crNumber),
      render: text => (
        <span style={{ fontWeight: '700', color: '#1a56db' }}>{text}</span>
      ),
    },
    {
      title: 'Change Title',
      dataIndex: 'title',
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (text, record) => (
        <span
          style={{
            backgroundColor: record.backgroundColor,
            color: record.textColor,
            padding: '4px 10px',
            borderRadius: '20px',
            fontSize: '0.8rem',
          }}
        >
          {text}
        </span>
      ),
      sorter: (a, b) => a.status.localeCompare(b.status),
    },
    {
      title: 'Initiator',
      dataIndex: 'initiator',
      sorter: (a, b) => a.initiator.localeCompare(b.initiator),
    },
    {
      title: 'Approvals',
      dataIndex: 'approvalsCount',
      render: (_, record) => {
        const approvalsColor =
          record.approvalsCount === record.approvalsTotal
            ? '#28a745'
            : record.approvalsCount >= record.approvalsTotal / 2
            ? '#ffc107'
            : '#dc3545';
        return (
          <span
            style={{
              backgroundColor: approvalsColor,
              color: '#fff',
              padding: '4px 10px',
              borderRadius: '20px',
              fontSize: '0.8rem',
            }}
          >
            {record.approvalsCount}/{record.approvalsTotal} Approved
          </span>
        );
      },
    },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'id',
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link className="me-2 p-2" onClick={() => handleEdit(record)}>
              <i data-feather="edit" className="feather-edit" />
            </Link>
            <Link className="confirm-text p-2" onClick={() => handleDelete(record.id)}>
              <i data-feather="trash-2" className="feather-trash-2" />
            </Link>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="table-responsive product-list">
      {(isLoading || isFetchDataLoading) && <LoadingSpinner />}
      <Table columns={columns} dataSource={filteredData} rowKey="id" />
    </div>
  );
};

export default CipRegisterTable;
